import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IMediaServersSettingsVm } from '../media-servers-settings-vm.model';
import { IMediaServersSettingsUm } from '../media-servers-settings-um.model';

@Injectable({ providedIn: 'root' })
export class MediaServersSettingsService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MediaServersSettings`;
  }

  get(): Observable<IMediaServersSettingsVm> {
    const headers = this.createHeaders();
    return this.http.get<IMediaServersSettingsVm>(this.baseUrl, { headers });
  }

  put(
    mediaServersSettingsUm: IMediaServersSettingsUm,
  ): Observable<IMediaServersSettingsVm> {
    const headers = this.createHeaders();
    return this.http.put<IMediaServersSettingsVm>(
      this.baseUrl,
      mediaServersSettingsUm,
      { headers },
    );
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
